import { render } from "./MessageUpdate.vue?vue&type=template&id=1d6d627a"
import script from "./MessageUpdate.vue?vue&type=script&lang=js"
export * from "./MessageUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__